import React from 'react';
import * as Yup from 'yup';
import { Form, Field, Button } from '@cordata/buffet';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import {
  authorizedPyPublicInstance as Public,
  authorizedInstanceNoBase as full,
} from '~/utils';

const initialValues = {
  body: '',
};

const validationSchema = Yup.object().shape({
  body: Yup.string().required(),
});

const Prompt = ({ subscription }) => (
  <Form
    displayName="ChatPrompt"
    validateOnBlur={false}
    validateOnChange={false}

    initialValues={initialValues}

    validationSchema={validationSchema}

    onSubmit={(values, {
      resetForm, setErrors, setSubmitting,
    }) => {
      full
        .get(subscription.relationships.realTimeTopic.related)
        .then(r => r.data.data)
        .then(r =>
          Public
          .post(`patient/${r.attributes.subjectUid}/chat`, { ...values }))
          .then(() =>
            resetForm(initialValues))
          .catch(setErrors)
          .then(() =>
            setSubmitting(false));
    }}
  >
    {({
      isSubmitting,
      dirty,
    }) => (
      <Row form>
        <Col xs>
          <Field
            name="body"
            label={false}
            groupClassName="mb-0"
            placeholder="Message channel members"
            disabled={!subscription || !subscription.id}
            required
          />
        </Col>

        <Col xs={1}>
          <Button block disabled={isSubmitting || !dirty || !subscription || !subscription.id}>
            Send{isSubmitting && 'ing ...'}
          </Button>
        </Col>
      </Row>
    )}
  </Form>
);

Prompt.propTypes = {
  subscription: PropTypes.string.isRequired,
};

export default Prompt;
